<template>
  <div v-if="isPublished && getBannerImage()" class="info-tile" :style="`background-color: ${getBackgroundColor}`">
    <a class="info-tile__block" :href="getBannerUrl" target="_blank">
      <img :src="getBannerImage()" :alt="getBannerTitle" />
    </a>
  </div>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
import { Env } from '@/shared/config/environment';

export default {
  props: {
    banner: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapGetters('layoutModule', ['isWideScreen', 'isDesktop', 'isTablet', 'isMobile']),
    isPublished() {
      if (!this.banner.publicationFrom || !this.banner.publicationTo) {
        return false;
      }

      return moment().isBetween(
        this.banner.publicationFrom,
        this.banner.publicationTo,
        null,
        '[]'
      );
    },
    getBannerTitle() {
      return this.banner.title;
    },
    getBannerUrl() {
      return this.banner.linkUA;
    },
    getBackgroundColor() {
      return `#${this.banner.color}`;
    },
  },
  methods: {
    getBannerImage() {
      if (this.isWideScreen && this.banner?.imgWide) {
        const img = this.banner?.imgWide;
        return `${Env.server.admin}/${img}`;
      } else if (this.isDesktop && this.banner?.imgDesktop) {
        const img = this.banner?.imgDesktop;
        return `${Env.server.admin}/${img}`;
      } else if (this.isTablet && this.banner?.imgTablet) {
        const img = this.banner?.imgTablet;
        return `${Env.server.admin}/${img}`;
      } else if (this.isDesktop && this.banner?.imgAdaptive) {
        const img = this.banner?.imgAdaptive;
        return `${Env.server.admin}/${img}`;
      } else {
        const img = this.banner?.imgDesktop || this.banner?.imgTablet || this.banner?.imgAdaptive || '';
        return `${Env.server.admin}${img}`;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.info-tile {
  display: flex;
  width: 100%;

  @media (min-width: 1050px) {
    padding-left: 151px;
  }

  &__block {
    display: flex;
    justify-content: center;
    width: 100%;
  }
}
</style>
